import React, { useEffect, useMemo, useState } from "react";
import { Button } from "@mui/material";
import Tab from "../../components/Tab/Tab";
import PendingContent from "./PendingContent";
import ActiveVouchersContent from "./ActiveVouchersContent";
import ExpiredRedeemedContent from "./ExpiredRedeemedContent";
import VoucherItem from "./VoucherItem";
import SelectDropdown from "../../components/Form/SelectDropdown";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import TextInput from "../../components/Form/TextInput";
import RadioInput from "../../components/Form/RadioInput";
import { DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import { BodyVoucher, CoeVoucher, PARFVoucher } from "./UserData";
import VoucherCard from "./VoucherCard";
import { ReactComponent as BackIcon } from "../../images/back.svg";
import CustomSlider from "../../components/Slider/CustomSlider";
import axios from "../../axios/axios";
import FlooringVoucherFormModal from "./FlooringVoucherFormModal";
import { toast } from "react-toastify";
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router-dom";
import { CommomPermission } from "../../common/Constants";
const DefaultVoucher = {
  COE: { isChecked: true, index: 0 },
  PARF: { isChecked: false, index: 1 },
  BODYONLY: { isChecked: false, index: 2 },
};
const DefaultChecked = {
  COE: {
    isSelected: false,
    isDisabled: false,
    interest: "",
  },
  PARF: {
    isSelected: false,
    isDisabled: false,
    interest: "",
  },
  BODYONLY: {
    isSelected: false,
    isDisabled: false,
    interest: "",
  },
};
const DefaultFormValues = {
  vouchers: [
    {
      flooring_product: "COE",
      interest_rate: "",
      customer_type: "2",
      max_redemption: "",
      redemption_rule: "0",
      voucher_qty_type: "0",
      qty: "",
      start_period: "",
      end_period: "",
      amount_from: "",
      amount_to: "",
      active: false,
    },
    {
      flooring_product: "PARF",
      interest_rate: "",
      customer_type: "2",
      max_redemption: "",
      redemption_rule: "0",
      voucher_qty_type: "0",
      qty: "",
      start_period: "",
      end_period: "",
      amount_from: "",
      amount_to: "",
      active: false,
    },
    {
      flooring_product: "BODYONLY",
      interest_rate: "",
      customer_type: "2",
      max_redemption: "",
      redemption_rule: "0",
      voucher_qty_type: "0",
      qty: "",
      start_period: "",
      end_period: "",
      amount_from: "",
      amount_to: "",
      active: false,
    },
  ],
};

const DefaultSelectedOption = {
  COE: {
    voucher_qty_type: "0",
  },
  PARF: {
    voucher_qty_type: "0",
  },
  BODYONLY: {
    voucher_qty_type: "0",
  },
};
const defaultEdit = {
  edit: false,
  item: "",
  type: ''
};
const FlooringVouchers = () => {
  const location = useLocation();
  const pagePermission = location.state !== null ? location.state : CommomPermission;
  const accessToken = localStorage.getItem('agentModuleToken');
  console.log("FLOOrVOUCHERPERMISSION", pagePermission);
  const [formValues, setFormValues] = useState(DefaultFormValues);

  const [selectedItem, setSelectedItem] = useState("COE");
  const [activeTab, setActiveTab] = useState(0); // Initialize the active tab as needed
  const [showCreateNew, setShowCreateNew] = useState(localStorage.getItem("showCreateNew") !== null ? localStorage.getItem("showCreateNew") === "true" : false); // State to toggle the create new voucher view
  const [isChecked, setIsChecked] = useState(DefaultVoucher);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [RedemptionsRule, setRedemptionRule] = useState([]);
  const [formCurrentValues, setFormCurrentValues] = useState([]);
  const [flooringVouchers, setFlooringVouchers] = useState({});
  const [isEdit, setIsEdit] = useState(defaultEdit);
  const [selectedOption, setSelectedOption] = useState(DefaultSelectedOption);
  const [vouchers, setVouchers] = useState(DefaultChecked);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [finishStatus, setfinishStatus] = useState(false);
  const [flooringRateStatus, setFlooringRateStatus] = useState({
    COE: true,
    PARF: true,
    BODYONLY: true
  })


  const tabs = ["Active Vouchers", "Pending", "Expired/Redeemed"]; // Define your tabs array

  const PresetFormValues = (keyword, index, initial) => {
    const initialItem = JSON.parse(localStorage.getItem(keyword));
    if (
      initialItem !== null &&
      initialItem !== undefined &&
      Object.keys(initialItem)?.length > 0
    ) {
      const FormValue = formValues?.vouchers?.filter(
        (it) => it?.flooring_product !== keyword
      );
      FormValue.splice(index, 0, initialItem);
      if (FormValue?.length > 0) {
        setFormValues({
          vouchers: FormValue,
        });
        setSelectedOption((prevState) => ({
          ...prevState,
          [`${keyword}`]: {
            ...prevState[keyword],
            voucher_qty_type: initialItem?.voucher_qty_type,
          },
        }));
        setVouchers((prevState) => ({
          ...prevState,
          [`${keyword}`]: {
            ...prevState[keyword],
            interest: initialItem?.interest,
            isSelected: !prevState[keyword]?.isSelected,
            isDisabled: initialItem?.active,
          },
        }));
      }
    } else {
      return;
    }
  };

  const GetFloorVoucherSettings = async () => {
    const resp = await axios.get("/flooring/voucher/settings", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp?.status < 400) {
      setCustomerOptions(resp.data?.data?.customer_type);
      setRedemptionRule(resp.data?.data?.voucher_redemption_rule);
    }
  };

  const GetFlooringVouchers = async () => {
    const resp = await axios.get("/flooring/voucher", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp.status < 400) {
      setFlooringVouchers(resp.data?.data);
    }
  };

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  const SetLocalStorage = (val) => {
    localStorage.setItem("showCreateNew", val);

  }

  const handleCreateNewClick = () => {
    setShowCreateNew(true);
    SetLocalStorage(true);
  };

  const HandleEdit = async (id, item, type) => {
    const voucherName = item?.replace(/ /g, "");
    const index = DefaultVoucher[voucherName]?.index;
    const resp = await axios.get(`/flooring/voucher/show/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp?.status < 400) {
      const temp = resp.data?.data;
      const obj = {
        ...temp,
        active: temp?.active == 1 ? false : true,
        customer_type: temp?.customer_type?.value,
        flooring_product: temp?.flooring_product?.value,
        redemption_rule: temp?.redemption_rule?.value,
        end_period:
          temp?.end_period === "Further Notice" ? "" : temp?.end_period,
      };
      const FormValue = formValues?.vouchers?.filter(
        (it) => it?.flooring_product !== voucherName
      );
      FormValue.splice(index, 0, obj);
      console.log("FORM VALUES", obj);
      setFormValues({
        vouchers: FormValue,
      });
      setSelectedItem(voucherName);
      setIsChecked((prevState) => ({
        ...DefaultVoucher,
        [voucherName]: {
          ...prevState[voucherName],
          isChecked: prevState[voucherName]?.isChecked
            ? prevState[voucherName]?.isChecked
            : true,
        },
      }));
      setVouchers((prevState) => ({
        ...prevState,
        [voucherName]: {
          ...prevState[voucherName],
          isSelected: prevState[voucherName]?.isSelected
            ? prevState[voucherName]?.isSelected
            : true,
          isDisabled: temp?.active == 1 ? false : true,
          interest: temp?.interest_rate,
        },
      }));
      setSelectedOption((prevState) => ({
        ...prevState,
        [voucherName]: {
          ...prevState[voucherName],
          voucher_qty_type: temp?.voucher_qty_type?.value,
        },
      }));
      setIsEdit({
        edit: true,
        item: voucherName,
        type: type
      });
      setShowCreateNew(true);
      SetLocalStorage(true)
    }
  };

  const HandleDelete = async (id, obj) => {
    const deleteObj = {
      flooring_product: obj?.flooring_product?.value,
      interest_rate: obj?.interest_rate,
      customer_type: obj?.customer_type?.value,
      max_redemption: obj?.max_redemption,
      redemption_rule: obj?.redemption_rule?.value,
      voucher_qty_type: obj?.voucher_qty_type?.value,
      qty: obj?.qty,
      start_period: obj?.start_period,
      end_period: obj?.end_period,
      amount_from: obj?.amount_from,
      amount_to: obj?.amount_to,
      active: obj?.active ? 0 : 1,
    };
    console.log("DELETE PARAMS", id, deleteObj);
    const resp = await axios.delete(
      `/flooring/voucher/delete/${id}`,
      deleteObj, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    );
    if (resp?.status < 400) {
      toast.success(resp.data?.message);
      Reset();
    }
  };

  const handleVoucherChange = (voucherName) => {
    if (voucherName === selectedItem) {
      return;
    }

    if (unsavedChanges || !ChecKIfFormFilled()) {
      toast.error(
        `Please save the changes before switching ${selectedItem} to another voucher!`
      );
      return;
    }

    const initialItem = JSON.parse(localStorage.getItem(voucherName));

    if (initialItem !== null && initialItem !== undefined) {
      setSelectedItem(voucherName);
      setIsChecked((prevState) => ({
        ...DefaultVoucher,
        [voucherName]: {
          ...prevState[voucherName],
          isChecked: !prevState[voucherName]?.isChecked,
        },
      }));
      PresetFormValues(voucherName, DefaultVoucher[voucherName]?.index, false);
    } else {
      setSelectedItem(voucherName);
      setIsChecked((prevState) => ({
        ...DefaultVoucher,
        [voucherName]: {
          ...prevState[voucherName],
          isChecked: !prevState[voucherName]?.isChecked,
        },
      }));
      setVouchers((prevState) => ({
        ...prevState,
        [voucherName]: {
          ...prevState[voucherName],
          isSelected: !prevState[voucherName]?.isSelected,
        },
      }));
    }
  };

  const handleDisableChange = (voucherName) => {
    setVouchers((prevState) => ({
      ...prevState,
      [voucherName]: {
        ...prevState[voucherName],
        isDisabled: !prevState[voucherName]?.isDisabled,
      },
    }));
  };

  const handleInputChange = (voucherName, value) => {

    setVouchers((prevState) => ({
      ...prevState,
      [voucherName]: {
        ...prevState[voucherName],
        interest: value,
      },
    }));
  };

  const Reset = () => {
    GetFlooringVouchers();
    localStorage.removeItem("COE");
    localStorage.removeItem("PARF");
    localStorage.removeItem("BODYONLY");
    localStorage.removeItem("showCreateNew")
    setfinishStatus(false);
    setVouchers(DefaultChecked);
    setIsChecked(DefaultVoucher);
    setFormValues(DefaultFormValues);
    setSelectedOption(DefaultSelectedOption);

  };

  const onSubmit = async (data) => {
    console.log("vouchers", vouchers)
    if (
      vouchers[selectedItem]?.interest !== "" ||
      vouchers[selectedItem]?.isDisabled
    ) {
      if (isEdit?.edit) {
        const temp = data?.vouchers
          ?.filter((it) => it?.flooring_product === selectedItem)
          .pop();
        const dataObj = {
          flooring_product: isEdit?.item,
          customer_type: temp?.customer_type,
          max_redemption: temp?.max_redemption,
          redemption_rule: temp?.redemption_rule,
          qty: temp?.qty,
          amount_from: temp?.amount_from,
          amount_to: temp?.amount_to,
          voucher_qty_type: selectedOption[selectedItem]?.voucher_qty_type,
          interest_rate: vouchers[selectedItem]?.interest,
          active: vouchers[selectedItem]?.isDisabled ? 0 : 1,
          start_period:
            temp?.start_period !== null && temp?.start_period !== ""
              ? !isNaN(temp?.start_period)
                ? moment(temp?.start_period).format("DD-MM-YYYY")
                : temp?.start_period
              : "",
          end_period:
            temp?.end_period !== null && temp?.end_period !== ""
              ? !isNaN(temp?.end_period)
                ? moment(temp?.end_period).format("DD-MM-YYYY")
                : temp?.end_period
              : "",
        };
        const resp = await axios.put(
          `/flooring/voucher/update/${temp?.id}`,
          dataObj,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (resp.status < 400) {
          toast.success(resp.data?.message);
          setIsEdit({
            edit: false,
            item: "",
            type: ""
          });
          setShowCreateNew(false);
          setfinishStatus(false);
          SetLocalStorage(false);
          Reset();
        }
      } else {
        const temp = data?.vouchers
          ?.filter((it) => it?.flooring_product === selectedItem)
          .pop();
        const dataObj = {
          ...temp,
          voucher_qty_type: selectedOption[selectedItem]?.voucher_qty_type,
          interest: vouchers[selectedItem]?.interest,
          active: vouchers[selectedItem]?.isDisabled,
        };
        localStorage.setItem(`${selectedItem}`, JSON.stringify(dataObj));
        toast.success(`${selectedItem}-Form values saved`)
      }
    } else {
      toast.error("Please enter interest value", 3000);
    }
  };

  const FinalSubmit = async () => {
    const temp = formCurrentValues?.map((item) => {
      console.log(
        "INSID MAP CONDITION",
        item,
        item?.interest,
        vouchers[item?.flooring_product]?.isDisabled
      );
      if (
        flooringRateStatus[item?.flooring_product] &&
        vouchers[item?.flooring_product]?.interest !== "" ||
        vouchers[item?.flooring_product]?.isDisabled
      ) {
        return {
          ...item,
          interest_rate:
            item?.interest !== undefined
              ? item?.interest
              : vouchers[item?.flooring_product]?.interest !== null
                ? vouchers[item?.flooring_product]?.interest
                : "",
          active: item.active ? 0 : 1,
          start_period:
            item?.start_period !== ""
              ? moment(item.start_period)?.format("DD-MM-YYYY")
              : "",
          end_period:
            item?.end_period !== ""
              ? moment(item.end_period)?.format("DD-MM-YYYY")
              : "",
        };
      }
    });

    console.log("temp", temp, vouchers)

    if (temp?.includes(undefined)) {
      toast.error("Please fill the voucher details (or) Disable it...", 3000);
      return;
    } else {
      const dataObj = {
        vouchers: temp?.filter(
          (it) =>
            it?.interest_rate !== undefined &&
            it?.interest_rate !== "" &&
            it?.interest_rate !== null
        ),
      };
      try {
        if (dataObj?.vouchers?.length > 0) {
          console.log("FINAL FORM VALUES", dataObj);

          const resp = await axios.post("/flooring/voucher/create", dataObj, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          if (resp?.status < 400) {
            toast.success(resp.data?.message);
            setShowCreateNew(false);
            setfinishStatus(false);
            SetLocalStorage(false);

            localStorage.removeItem("COE");
            localStorage.removeItem("PARF");
            localStorage.removeItem("BODYONLY");
            Reset();
          }
        } else {
          toast.error("No Active Data found please fill any one voucher.", 3000);
          return;
        }

      } catch (err) {
        if (err !== undefined) {
          if (err?.response.data.errors !== undefined && err?.response.data.errors?.length > 0) {
            err?.response.data.errors?.map((it) => {
              return toast.error(it, 3000);
            })
          } else {
            toast.error("Voucher Limit Reached", 3000)
          }
          console.log("ERROR", err?.response.data.errors)
        }

      }
    }
  };

  const handleOptionChange = (voucherName, event) => {
    setSelectedOption((prevState) => ({
      ...prevState,
      [voucherName]: {
        ...prevState[voucherName],
        voucher_qty_type: event.target.value,
      },
    }));
  };

  const ChecKIfFormFilled = () => {
    if (!Array.isArray(formCurrentValues)) {
      return false;
    }
    const temp = formCurrentValues
      ?.filter((it) => it?.flooring_product === selectedItem)
      ?.pop();

    const length = temp !== undefined ? Object.values(temp)?.filter((it) => it !== "")?.length : {};
    const localItem = JSON.parse(localStorage.getItem(selectedItem));
    return length >= 9 && localItem !== null
      ? true
      : length == 5 && vouchers[selectedItem]?.interest == ""
        ? true
        : localItem?.active
          ? true
          : false;
  };
  const CheckStorage = () => {
    PresetFormValues(selectedItem, DefaultVoucher[selectedItem]?.index, true);
  };

  const GetFlooringRates = async () => {
    const resp = await axios.get("/flooring/product", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp?.status < 400) {
      const temp = resp.data?.data?.products;
      if (temp?.length > 0) {
        const obj = temp?.map((it) => {
          return {
            name: `${it?.name?.replace(/ /g, '')}`,
            active: it?.active == 1 ? true : false
          }
        });
        var result = {};
        for (var i = 0; i < obj.length; i++) {
          result[obj[i].name] = obj[i].active;
        }
        if (Object.keys(result)?.length > 0) {
          Object.keys(result).map((keyName, i) => {
            setVouchers((prevState) => ({
              ...prevState,
              [keyName]: {
                ...prevState[keyName],
                isDisabled: result[keyName] ? false : true,
              },
            }));
          })
          setFlooringRateStatus(result);
        }
      }
    }
  }
  console.log("FLOORINGRATESTATUS", flooringRateStatus, vouchers)

  useEffect(() => {
    GetFloorVoucherSettings();
    GetFlooringVouchers();
    CheckStorage();
    GetFlooringRates();
  }, []);

  useEffect(() => {
    if (showCreateNew == false) {
      setIsEdit({
        edit: false,
        item: "",
        type: ""
      });
      setFormCurrentValues(DefaultFormValues);
    }
  }, [showCreateNew]);

  console.log("VOUCHERS", vouchers);

  console.log("BACK BUTTON CLICK", vouchers, showCreateNew, finishStatus)


  const onBackButtonEvent = (e) => {
    e.preventDefault();
    const COE = JSON.parse(localStorage.getItem("COE"));
    const PARF = JSON.parse(localStorage.getItem("PARF"));
    const BODYONLY = JSON.parse(localStorage.getItem("BODYONLY"));

    console.log("FORM CURRENT VALUES", !finishStatus)

    if (!finishStatus) {
      if (window.confirm("Do you want to leave this page without saving the data ?")) {
        setfinishStatus(true);
        Reset();
        setShowCreateNew(false);
      } else {
        window.history.pushState(null, null, window.location.pathname);
        setfinishStatus(false)
      }
    }
  }

  useEffect(() => {
    if (showCreateNew) {
      window.history.pushState(null, null, window.location.pathname);
      window.addEventListener('popstate', onBackButtonEvent);
      return () => {
        window.removeEventListener('popstate', onBackButtonEvent);
      };
    }
  }, [showCreateNew]);

  console.log("activeTab", activeTab);

  return (
    <section className="flooring-rates-section">
      <header className="common-header">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3">
            {showCreateNew ? (
              <span
                className="cursor-pointer"
                onClick={() => {
                  setShowCreateNew(false);
                  setfinishStatus(false);
                  SetLocalStorage(false);
                  setActiveTab(0);
                  Reset();
                }}
              >
                <BackIcon />
              </span>
            ) : null}
            {showCreateNew
              ? isEdit?.edit
                ? "Update Voucher"
                : "Create New Voucher"
              : "Flooring Vouchers"}
          </h1>
          {showCreateNew ? null : (
            <>
              {pagePermission?.create_permission == 1 && (
                <Button
                  type="button"
                  className="sav_btn bonus_btn"
                  onClick={handleCreateNewClick}
                >
                  <img
                    src="/images/add-circle-wh.svg"
                    alt="add"
                    className="hidden max-[700px]:block"
                  />
                  <span className="max-[700px]:hidden">Create New Voucher</span>
                </Button>
              )
              }
            </>
          )}
        </div>
      </header>
      <section>
        {showCreateNew ? null : (
          <div className="tab-section">
            <Tab
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />
          </div>
        )}
        <div className="tab-body-section">
          {activeTab === 1 &&
            !showCreateNew &&
            Object.keys(flooringVouchers)?.length > 0 && (
              <PendingContent
                pending_vouchers={flooringVouchers?.pending_vouchers}
                handleCreateNewClick={handleCreateNewClick}
                HandleEdit={HandleEdit}
                HandleDelete={HandleDelete}
                pagePermission={pagePermission}
              />
            )}
          {activeTab === 0 &&
            !showCreateNew &&
            Object.keys(flooringVouchers)?.length > 0 && (
              <ActiveVouchersContent
                active_vouchers={flooringVouchers?.active_vouchers}
                handleCreateNewClick={handleCreateNewClick}
                HandleEdit={HandleEdit}
                HandleDelete={HandleDelete}
                pagePermission={pagePermission}
              />
            )}
          {activeTab === 2 && !showCreateNew && (
            <ExpiredRedeemedContent
              expired_vouchers={flooringVouchers?.expired_vouchers}
              handleCreateNewClick={handleCreateNewClick}
              HandleEdit={HandleEdit}
              HandleDelete={HandleDelete}
              pagePermission={pagePermission}
            />
          )}
        </div>
      </section>

      {/* Create New Voucher */}
      <section className="flooring-body-section">
        {showCreateNew && (
          <div className="new-voucher-block">
            <div className="voucher-details">
              <div className="hr-line-menu">
                <div className="clear-block">
                  <h2>Voucher Details</h2>
                </div>
              </div>
              {isEdit?.edit ? (
                <div className="voucher-select-block">
                  {isEdit?.item == "COE" && (
                    <VoucherItem
                      name="COE"
                      isChecked={isChecked.COE?.isChecked}
                      onCheckChange={() => {
                        if (ChecKIfFormFilled()) {
                          handleVoucherChange("COE");
                        } else {
                          toast.error("Please save the changes...!");
                          return;
                        }
                      }}
                      isDisableChecked={vouchers.COE.isDisabled}
                      onDisableChange={() => handleDisableChange("COE")}
                      onInputChange={(e) => {
                        console.log("INPUT CHANGE", e);
                        handleInputChange("COE", e);
                      }}
                      value={vouchers.COE.interest}
                    />
                  )}

                  {isEdit?.item == "PARF" && (
                    <VoucherItem
                      name="PARF"
                      isChecked={isChecked.PARF?.isChecked}
                      onCheckChange={() => {
                        console.log("ChecKIfFormFilled", ChecKIfFormFilled());
                        if (ChecKIfFormFilled()) {
                          handleVoucherChange("PARF");
                        } else {
                          toast.error("Please save the changes...!");
                          return;
                        }
                      }}
                      isDisableChecked={vouchers.PARF.isDisabled}
                      onDisableChange={() => handleDisableChange("PARF")}
                      onInputChange={(e) => {
                        handleInputChange("PARF", e);
                      }}
                      value={vouchers.PARF.interest}
                    />
                  )}
                  {isEdit?.item == "BODYONLY" && (
                    <VoucherItem
                      name="BODY ONLY"
                      isChecked={isChecked.BODYONLY?.isChecked}
                      onCheckChange={() => {
                        if (ChecKIfFormFilled()) {
                          handleVoucherChange("BODYONLY");
                        } else {
                          toast.error("Please save the changes...!");
                          return;
                        }
                      }}
                      isDisableChecked={vouchers?.BODYONLY?.isDisabled}
                      onDisableChange={() => handleDisableChange("BODYONLY")}
                      onInputChange={(e) => {
                        handleInputChange("BODYONLY", e);
                      }}
                      value={vouchers.BODYONLY.interest}
                    />
                  )}
                </div>
              ) : (
                <div className="voucher-select-block">
                  {flooringRateStatus?.COE && (
                    <VoucherItem
                      addClass={`${"COE" === selectedItem
                        ? ""
                        : unsavedChanges || !ChecKIfFormFilled()
                          ? "unsaved"
                          : ""
                        }`}
                      name="COE"
                      isChecked={isChecked.COE?.isChecked}
                      onCheckChange={() => {
                        handleVoucherChange("COE");
                      }}
                      isDisableChecked={vouchers.COE.isDisabled}
                      onDisableChange={() => handleDisableChange("COE")}
                      onInputChange={(e) => {
                        console.log("INPUT CHANGE", e);
                        handleInputChange("COE", e);
                      }}
                      value={vouchers.COE.interest}
                    />
                  )}
                  {flooringRateStatus?.PARF && (
                    <VoucherItem
                      addClass={`${"PARF" === selectedItem
                        ? ""
                        : unsavedChanges || !ChecKIfFormFilled()
                          ? "unsaved"
                          : ""
                        }`}
                      name="PARF"
                      isChecked={isChecked.PARF?.isChecked}
                      onCheckChange={() => {
                        console.log("ChecKIfFormFilled", ChecKIfFormFilled());
                        handleVoucherChange("PARF");
                      }}
                      isDisableChecked={vouchers.PARF.isDisabled}
                      onDisableChange={() => handleDisableChange("PARF")}
                      onInputChange={(e) => {
                        handleInputChange("PARF", e);
                      }}
                      value={vouchers.PARF.interest}
                    />
                  )}
                  {flooringRateStatus?.BODYONLY && (

                    <VoucherItem
                      addClass={`${"BODYONLY" === selectedItem
                        ? ""
                        : unsavedChanges || !ChecKIfFormFilled()
                          ? "unsaved"
                          : ""
                        }`}
                      name="BODY ONLY"
                      isChecked={isChecked.BODYONLY?.isChecked}
                      onCheckChange={() => {
                        handleVoucherChange("BODYONLY");
                      }}
                      isDisableChecked={vouchers?.BODYONLY?.isDisabled}
                      onDisableChange={() => handleDisableChange("BODYONLY")}
                      onInputChange={(e) => {
                        handleInputChange("BODYONLY", e);
                      }}
                      value={vouchers.BODYONLY.interest}
                    />
                  )}
                </div>
              )}
              <div className="voucher-details-info">
                <p className="voucher-alert">
                  Use the <strong>Disable Voucher</strong> checkbox to disable a
                  specific vehicle type voucher.
                </p>
                <p>
                  This will be the interest rate that dealers will apply for in
                  the flooring application if they select this voucher, upon
                  vetting through the flooring application you can still counter
                  offer with another interest rate if you deem suitable.
                  However, it is recommended to adhere to the voucher rates for
                  a better customer experience.
                </p>
              </div>
              <div className="hr-line-menu" />
              <div className="hr-line-menu">
                <div className="clear-block">
                  <h2>
                    {isChecked[selectedItem]?.index === 0
                      ? "COE "
                      : isChecked[selectedItem]?.index === 1
                        ? "PARF "
                        : isChecked[selectedItem]?.index === 2
                          ? "BODY ONLY "
                          : ""}
                    Voucher Requirements
                  </h2>
                </div>
              </div>
              <div>
                <FlooringVoucherFormModal
                  onSubmit={onSubmit}
                  customerOptions={customerOptions}
                  RedemptionsRule={RedemptionsRule}
                  handleOptionChange={handleOptionChange}
                  selectedOption={selectedOption}
                  selectedItem={selectedItem}
                  selectedFormIndex={isChecked[selectedItem]?.index}
                  formValues={formValues}
                  setFormCurrentValues={setFormCurrentValues}
                  vouchers={vouchers}
                  isEdit={isEdit}
                  flooringRateStatus={flooringRateStatus}
                />
              </div>
              <div className="voucher-requirement"></div>
            </div>

            <div className="flex justify-end items-center mt-7">
              {!isEdit?.edit && (
                <Button
                  type="button"
                  className="sav_btn"
                  onClick={() => {
                    FinalSubmit();
                  }}
                >
                  Create Voucher
                </Button>
              )}
            </div>
          </div>
        )}
      </section>
    </section>
  );
};

export default FlooringVouchers;
